import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import useLanguage from "../common_hooks/useLanguage";
import { convert_to_currency_with_unit } from "../../App/validation/convert_to_currency_with_unit";

const harga_hardcode_urgent = {
  license_sini_ai: {
    IDR: 199000,
    USD: 9,
    MYR: 29,
  },
  license_sini_data: {
    IDR: 399000,
    USD: 23.99,
    MYR: 103.99,
  },
};

const AddonFeatureChecklist = ({
  is_active = false,
  value = 0,
  labels = [],
  onChange,
  is_ever_purchase,
  month,
  license_features,
  currency,
}) => {
  const { dict, language } = useLanguage();

  const containerStyle = {
    padding: "0 2px 2px 2px",
    fontFamily: "sans-serif",
    width: "100%",
    maxWidth: "400px",
  };

  const checkbox_style = {
    "&.Mui-checked": {
      color: "#000",
    },
    fontSize: "12px",
  };

  return (
    <div style={containerStyle}>
      <h4 style={{ fontSize: "16px", marginBottom: "6px" }}>
        {dict["Optional Add-ons"][language]}
      </h4>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {labels.map((item, idx) => {
          const lic_key = license_features?.find(
            (l, lic_idx) => item?.value === lic_idx
          )?.key;
          return (
            <FormControlLabel
              key={idx}
              control={
                <Checkbox
                  checked={
                    !is_ever_purchase && month === 1 ? true : value > idx
                  }
                  value={item?.value}
                  onChange={(e) => {
                    if (is_ever_purchase || (month !== 1 && !is_ever_purchase))
                      onChange(e.target.value);
                  }}
                  sx={checkbox_style}
                  size="small"
                />
              }
              label={
                <div
                  style={{ display: "flex", gap: "5px", fontSize: "0.9rem" }}
                >
                  <p>{`${item.label}`}</p>
                  <p>
                    {"("}
                    {convert_to_currency_with_unit({
                      currency,
                      value: harga_hardcode_urgent?.[lic_key]?.[currency],
                    })}
                    {`/${dict["month"][language]})`}
                  </p>
                  {/* {!is_ever_purchase && <p title='New user get free add-ons' style={{ color: "green" }}>{` (${dict["FREE"][language]})`}</p>} */}
                </div>
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default AddonFeatureChecklist;
